import { SubVertical } from 'common/constants/verticalService'

export enum TemplateManagerKey {
  ART_ARTIST_LIST = 'ART_ARTIST_LIST',
  ART_HOME_BANNER = 'ART_HOME_BANNER',
  ART_HOME_WEEKLY_BANNER = 'ART_HOME_WEEKLY_BANNER',
  ART_BRAND_HOME_BANNER = 'ART_BRAND_HOME_BANNER',
  FOOD_LOCAL_MARKET_BANNER = 'FOOD_LOCAL_MARKET_BANNER',
  HOME_MEAL_EVENT_BANNER = 'HOME_MEAL_EVENT_BANNER',
  HOME_MEAL_VIDEO_BANNER = 'HOME_MEAL_VIDEO_BANNER',
  TRADITIONAL_ALCOHOL_HOME_BANNER = 'TRADITIONAL_ALCOHOL_HOME_BANNER',
  GIFT_ICON_MANAGER = 'GIFT_ICON_MANAGER',
  GIFT_NPAY_CARD_LIST = 'GIFT_NPAY_CARD_LIST',
  GIFT_NPAY_CARD_TYPE = 'GIFT_NPAY_CARD_TYPE',
  GIFT_RECOMMEND_TARGET = 'GIFT_RECOMMEND_TARGET',
  REVIEW_EVENT_BANNER = 'REVIEW_EVENT_BANNER',
  LOCAL_FOOD_HOME_BANNER = 'LOCAL_FOOD_HOME_BANNER',
  DIRECT_FARM_HOME_BANNER = 'DIRECT_FARM_HOME_BANNER',
  DIRECT_FARM_HOME_ALL = 'DIRECT_FARM_HOME_ALL',
}

interface TemplateManagerKeyConfig {
  subVertical?: SubVertical
  templateValidationKeys?: string[]
}

type TemplateManagerKeyConfigType = { [key in TemplateManagerKey]: TemplateManagerKeyConfig }

export const templateMangerKeyConfig: TemplateManagerKeyConfigType = {
  ART_ARTIST_LIST: {
    subVertical: SubVertical.ART,
  },
  ART_HOME_BANNER: {
    subVertical: SubVertical.ART,
    templateValidationKeys: ['id', 'imageUrl', 'linkUrl', 'title', 'subTitle'],
  },
  ART_HOME_WEEKLY_BANNER: {
    subVertical: SubVertical.ART,
    templateValidationKeys: ['id', 'imageUrl', 'brand', 'windowProducts'],
  },
  ART_BRAND_HOME_BANNER: {
    subVertical: SubVertical.ART,
    templateValidationKeys: ['id', 'imageUrl', 'brand', 'windowProducts'],
  },
  FOOD_LOCAL_MARKET_BANNER: {
    subVertical: SubVertical.LOCAL_FOOD,
    templateValidationKeys: ['id', 'imageUrl'],
  },
  HOME_MEAL_EVENT_BANNER: {
    subVertical: SubVertical.HOME_MEAL,
    templateValidationKeys: ['id', 'title', 'imageUrl'],
  },
  HOME_MEAL_VIDEO_BANNER: {
    subVertical: SubVertical.HOME_MEAL,
    templateValidationKeys: ['id', 'title', 'imageUrl'],
  },
  TRADITIONAL_ALCOHOL_HOME_BANNER: {
    subVertical: SubVertical.TRADITIONAL_ALCOHOL,
    templateValidationKeys: ['id', 'imageUrl', 'linkUrl', 'title', 'subTitle'],
  },
  GIFT_ICON_MANAGER: {
    subVertical: SubVertical.GIFT,
  },
  GIFT_NPAY_CARD_LIST: {
    subVertical: SubVertical.GIFT,
  },
  GIFT_NPAY_CARD_TYPE: {
    subVertical: SubVertical.GIFT,
  },
  GIFT_RECOMMEND_TARGET: {
    subVertical: SubVertical.GIFT,
  },
  REVIEW_EVENT_BANNER: {
    templateValidationKeys: ['mobileBannerAtReviewForm', 'pcBannerAtReviewForm'],
  },
  LOCAL_FOOD_HOME_BANNER: {
    subVertical: SubVertical.LOCAL_FOOD,
    templateValidationKeys: ['id', 'imageUrl', 'linkUrl', 'title', 'subTitle', 'region'],
  },
  DIRECT_FARM_HOME_BANNER: {
    subVertical: SubVertical.DIRECT_FARM,
    templateValidationKeys: ['id', 'imageUrl', 'linkUrl', 'title', 'subTitle'],
  },
  DIRECT_FARM_HOME_ALL: {
    subVertical: SubVertical.DIRECT_FARM,
    templateValidationKeys: ['id', 'imageUrl', 'linkUrl', 'title', 'subTitle'],
  },
}
